import { useAuth } from "./useAuth";

/**
 * Membership test for the hardcoded email allowlists that gate two screens.
 *
 * These lists ship in the JS bundle and are readable by anyone who loads the
 * app, so this is a UX gate, not a security control — `support_api` is the only
 * real boundary. See src/hooks/AGENTS.md.
 *
 * Comparison is case-insensitive and trimmed on both sides. The previous
 * per-hook copies used an exact `Array.includes`, so an address differing only
 * in capitalisation silently lost access.
 */
export default function useEmailAllowlist(allowlist: string[]) {
  const { user } = useAuth();
  if (!user?.mail) return false;

  const mail = user.mail.trim().toLowerCase();
  return allowlist.some((entry) => entry.trim().toLowerCase() === mail);
}
